export const miraMainTabs = [
    { id: 'today', label: 'Today', routeId: 'today', icon: 'home' },
    { id: 'topics', label: 'Topics', routeId: 'topics', icon: 'leaf' },
    { id: 'relationships', label: 'Relationships', routeId: 'relationships', icon: 'users' },
    { id: 'memory', label: 'Memory', routeId: 'memory', icon: 'book-open' },
];
export function isMiraMainTabId(value) {
    return miraMainTabs.some((tab) => tab.id === value);
}
